
import Dropdown from '@/components/ui/dropdown.vue';
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'Faq',

  components: {
    Dropdown,
    WpImage,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      selectedFaq: null,
      dropdownIndex: null,
    };
  },

  methods: {
    selectFaq(i) {
      this.selectedFaq === i
        ? (this.selectedFaq = null)
        : (this.selectedFaq = i);
    },
    openCloseDropdowns(index) {
      if (this.dropdownIndex === index) {
        this.dropdownIndex = null;
      } else {
        this.dropdownIndex = index;
      }
    },
  },
};
